import * as React from 'react';
import { CharacteristicDataService, SurveyVersionDataService, Auth } from '../../services';
import { Characteristic, SurveyVersion } from '../../models';
import { NavLink } from 'react-router-dom';
import { ListingState, BaseRouteProps } from '../../interfaces';
import { DataGrid, PVAPage } from '../../components';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';
import { UserStore } from '../../stores';
import { Roles } from '../../stores/Constants';

interface CharacteristicListingProps extends BaseRouteProps<{ id: number }> {
    UserStore?: UserStore;
    Auth?: Auth;
}

interface CharacteristicListingState extends ListingState<Characteristic> {
    surveyIsPublished: boolean;
}

@inject('UserStore', 'Auth') @observer
export class CharacteristicListing extends React.Component<CharacteristicListingProps, CharacteristicListingState> {
    private characteristicDataService = new CharacteristicDataService(this.props.notificationService);
    private surveyVersionDataService = new SurveyVersionDataService(this.props.notificationService);

    @computed get userRole() {
        return this.props.UserStore!.userInfo.userRole;
    }

    @computed get isSuperAdmin() {
        return this.props.Auth!.userRoleIn([Roles.SuperAdmin]);
    }

    constructor(props: CharacteristicListingProps) {
        super(props);

        this.state = {
            entities: new Array<Characteristic>(),
            surveyIsPublished: true
        };
    }

    public componentDidMount() {
        this.surveyVersionDataService.get(this.props.match.params.id).then((surveyVersion: SurveyVersion) => {
            this.setState({
                surveyIsPublished: surveyVersion.published !== null ? true : false
            });

            this.characteristicDataService.getAllBySurveyVersion(surveyVersion).then((characteristics: Characteristic[]) => {
                this.setState({
                    entities: characteristics
                });
            });
        });
    }

    public render() {
        const otherListData = this.state.entities.sort((a: Characteristic, b: Characteristic) => {
            if (a.characteristicGroupID && !b.characteristicGroupID) {
                return -1;
            } else if (!a.characteristicGroupID && b.characteristicGroupID) {
                return 1;
            }
            if (a.characteristicGroupID && b.characteristicGroupID) {
                if (a.characteristicGroupID > b.characteristicGroupID) {
                    return 1;
                } else if (a.characteristicGroupID < b.characteristicGroupID) {
                    return -1;
                }
            }

            if (a.sort > b.sort) {
                return 1;
            } else if (a.sort < b.sort) {
                return -1;
            }
            return 0;
        }).map((entity: Characteristic, index: number) => {
            return {
                'Name': (index + 1) + '. ' + entity.name,
                'Modified': new Date(entity.modifiedDate).toLocaleDateString(),
                'ActionKey': entity.id
            };
        });

        const actionsColumn = ({ value }: any) => {
            return (
                <NavLink className="btn btn-default btn-block" to={`/characteristic/${value}`}>View</NavLink>
            );
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'Modified' },
            { id: 'ActionKey', title: 'Actions', width: '88px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Buttons>
                        <NavLink to={'/surveyversion/' + this.props.match.params.id}>
                            <span className="glyphicon glyphicon-arrow-left" />
                        </NavLink>
                        {(this.isSuperAdmin && !this.state.surveyIsPublished) &&
                            <NavLink to={'/surveyversion/' + this.props.match.params.id + '/characteristics/create'}>
                                <span className="glyphicon glyphicon-plus" />
                            </NavLink>
                        }
                    </PVAPage.Header.Buttons>
                    <div className="title">Characteristics</div>
                </PVAPage.Header>

                <PVAPage.Body>
                    <DataGrid entities={otherListData} columns={columnDefs} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }
}



// WEBPACK FOOTER //
// ./src/components/characteristic/CharacteristicListing.tsx